module.exports = __webpack_public_path__ + "files/f5afb2fdccbfa2f710c891d83be520c1.png";